import { render, staticRenderFns } from "./TaskBoard.vue?vue&type=template&id=890de2f8&"
import script from "./TaskBoard.vue?vue&type=script&lang=js&"
export * from "./TaskBoard.vue?vue&type=script&lang=js&"
import style0 from "./TaskBoard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports